import { useCallback, useEffect, useState } from 'react'
import { WatchListsApi } from '../api/WatchListApi'
import { WatchListItem } from 'types/WatchListEntity'
import { NewsItem } from 'types/NewsItem'
import { IssueEntity } from 'types/IssueEntity'
import { WarrantEntity } from 'types/WarrantEntity'
import { CompanyEntity } from 'types/CompanyEntity'

const watchListsApi = new WatchListsApi()

export const useWatchListFilter = (onlyInWatchLists: boolean) => {
    const [watchListsItems, setWatchListItems] = useState<WatchListItem[] | null>(null)

    useEffect(() => {
        void (async () => {
            const [result] = await watchListsApi.getAll()

            setWatchListItems(result.items)
        })()
    }, [])

    const watchListFilter = useCallback(
        (item: Partial<NewsItem> & Partial<IssueEntity> & Partial<WarrantEntity> & Partial<CompanyEntity>) => {
            if (!onlyInWatchLists) return true
            if (!watchListsItems) return false

            return watchListsItems.find(({ advisorId, companyId, investorId, issueId, warrantId }) => {
                return (
                    (advisorId && item.financialAdvisors?.find((fa) => fa.advisorId === advisorId)) ||
                    (advisorId && item.legalAdvisors?.find((la) => la.advisorId === advisorId)) ||
                    item.entityId === issueId ||
                    item.entityId === warrantId ||
                    item.companyId === companyId ||
                    item.id === companyId ||
                    item.id === warrantId ||
                    item.id === issueId ||
                    (item.investors || item.issueData?.investors || item.warrantData?.investors)?.some(
                        (i) => i.investorId === investorId,
                    ) ||
                    item.linkedIssue?.investors?.some((i) => i.investorId === investorId)
                )
            })
        },
        [watchListsItems, onlyInWatchLists],
    )

    return { watchListFilter }
}
